import ReactDOM from 'react-dom';
import './vendor';
import App from './App';

// NOTE: Place all 3rd-party lib initialization into 'vendor.js', to keep
// this file small and clean. There shouldn't be any need to add anything
// here, other than the below ReactDOM bootstrapping.
// eslint-disable-next-line react/jsx-filename-extension
ReactDOM.render(<App />, document.getElementById('root'));
